// eslint-disable-next-line @typescript-eslint/naming-convention
export const ACCESS_TOKEN_KEY = 'accessToken';
export const DATA = 'data';
export const FIRST_LOGIN = 'firstLogin';